import * as tslib_1 from "tslib";
export function paginate(_a) {
    var apollo = _a.apollo, query = _a.query, perPage = _a.perPage, itemsPropertyName = _a.itemsPropertyName;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var items, totalCount, offset, limit, variables, response, page;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = [];
                    totalCount = null;
                    offset = 0;
                    limit = perPage;
                    _b.label = 1;
                case 1:
                    if (!(totalCount === null || totalCount > items.length)) return [3 /*break*/, 3];
                    variables = {
                        limit: limit,
                        offset: offset,
                    };
                    return [4 /*yield*/, apollo
                            .query({ query: query, variables: variables })
                            .toPromise()];
                case 2:
                    response = _b.sent();
                    page = response.data[itemsPropertyName];
                    items.push.apply(items, tslib_1.__spread(page.items));
                    offset += limit;
                    totalCount = page.totalCount;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, items];
            }
        });
    });
}
